module.exports = __webpack_public_path__ + "static/media/caroline_debBaruah.650b6d9d.png";